import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, BackButton, EmployeeDataForm } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddEmployee = function AddEmployee(_ref) {
  var history = _ref.history;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "2em",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/employee');
    }
  }))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0421\u044A\u0434\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B"
  }, ___EmotionJSX(EmployeeDataForm, {
    onSubmit: function onSubmit() {
      return history.push('/employee');
    }
  })))));
};

AddEmployee.propTypes = {
  history: PropTypes.object
};
export default AddEmployee;